import * as z from 'zod/mini';
import { Gender } from '../models/Gender.js';
import { defineFormInput } from './defineFormInput.js';
/**
 * Schema for gender input configuration.
 */
export const GenderInput = defineFormInput({
    type: 'GENDER',
    input: {
        question: z.string(),
        help: z.optional(z.string()),
    },
    value: {
        gender: Gender,
    },
});
//# sourceMappingURL=GenderInput.js.map